import type { Migration } from './types'

export type MigrationFileInput =
  | readonly [filename: string, sql: string]
  | {
      filename: string
      sql: string
    }

export function loadMigrationFiles(
  files: readonly MigrationFileInput[],
): Migration[] {
  const migrations: Migration[] = []

  for (const file of files) {
    const { filename, sql } = normalizeMigrationFile(file)

    if (!filename.endsWith('.sql')) continue

    const match = filename.match(/^(\d+)_/)
    if (!match) continue

    migrations.push({
      version: match[1],
      filename,
      sql,
      noTransaction: false,
    })
  }

  migrations.sort((a, b) => a.version.localeCompare(b.version))

  return migrations
}

function normalizeMigrationFile(file: MigrationFileInput): {
  filename: string
  sql: string
} {
  if (isMigrationTuple(file)) {
    return {
      filename: file[0],
      sql: file[1],
    }
  }

  return {
    filename: file.filename,
    sql: file.sql,
  }
}

function isMigrationTuple(
  file: MigrationFileInput,
): file is readonly [filename: string, sql: string] {
  return Array.isArray(file)
}
